import Vue from 'vue'
import BinnacleTransformer from './../../transformers/sinister/binnacle'
/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const sendBinnacle = (payload, affectedId) => {
  const transformed = BinnacleTransformer.send(payload)
  return Vue.$http.post(`sinisters/affected/${affectedId}/extranet_binnacle/`, transformed)
    .then(({ data }) => {
      const transformedResp = BinnacleTransformer.fetch(data)
      return transformedResp
    })
    .catch((err) => { throw err })
}

export default sendBinnacle


// WEBPACK FOOTER //
// ./src/services/extranet/sendBinnacle.js